export const armyPhotoSize = {
  width: 1200,
  height: 1200,
};
